module.exports = __webpack_public_path__ + "static/img/bg.6d9d7a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 34